/*!
 * Copyright (c) 2015-2020 Cisco Systems, Inc. See LICENSE file.
 */

import {registerPlugin} from '@webex/webex-core';

import Logger from './logger';
import config from './config';

registerPlugin('logger', Logger, {
  config,
  replace: true,
});

export {default, levels} from './logger';
